export default "__VITE_PUBLIC_ASSET__5ec5070e__"